import { render, staticRenderFns } from "./QuestionsTrivia.vue?vue&type=template&id=7f656962&scoped=true"
import script from "./QuestionsTrivia.vue?vue&type=script&lang=js"
export * from "./QuestionsTrivia.vue?vue&type=script&lang=js"
import style0 from "./QuestionsTrivia.vue?vue&type=style&index=0&id=7f656962&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f656962",
  null
  
)

export default component.exports